import type { GetSingleDocumentUploadFieldValueProps } from "./document-upload-field.type";
import type {
  Document,
  DocumentUploadFilePayload,
  DocumentUploadPayload,
} from "@/entities/document";
import type { UploadExistingFile, UploadNewFile } from "@/modules/upload-file";
import type { Nullable } from "@/types";

import { convertDocumentToExistingFilePayload } from "@/entities/document";

export const convertDocumentToUploadExistingFile = (
  document?: Nullable<Document>
): UploadExistingFile | undefined => {
  if (!document) return undefined;

  return {
    uid: `${document.id}`,
    name: document.name,
    url: document.url,
    path: document.path,
  };
};

export const getSingleDocumentUploadFieldValue = ({
  formValue,
  defaultDocument,
}: GetSingleDocumentUploadFieldValueProps): DocumentUploadPayload => {
  const defaultValue =
    convertDocumentToExistingFilePayload(defaultDocument) ?? null;

  // Field has not been touched yet
  if (!formValue) return defaultValue;

  // Field has been touched and is empty, return null to reset DB
  if (formValue.length === 0) return null;

  // Process new uploaded file or existing
  return (
    convertUploadFormItemValueToDocumentUploadPayload(formValue[0]) ??
    defaultValue
  );
};

export const convertUploadFormItemValueToDocumentUploadPayload = (
  file: UploadExistingFile | UploadNewFile
): DocumentUploadFilePayload | undefined => {
  // UploadNewFile
  if ("originFileObj" in file && file.originFileObj) {
    return file.originFileObj;
  }

  // UploadExistingFile
  if ("path" in file && file.path) {
    return { name: file.name, path: file.path };
  }

  return undefined;
};
